import React from "react";

export const queerIndigenous = {
  title: "The Handbook to the Lore and Wisdom of the Queer Indigenous",
  date: "2017",
  about: (
    <>
      <p>
        Playing with symbols of greek national pride and displays of queerness,{" "}
        <i>The Handbook to the Lore and Wisdom of the Queer Indigenous</i> opts
        for a direct and intentionally puerile approach to expressing
        exasperation with certain strata of contemporary greek society which
        regularly indulge in various over-the-top rituals of ancestor-worship
        and pathetic displays of machismo. Indeed, the surest way to mortify
        those clinging to the triptych <em>πατρίς-θρησκεία-οικογένεια</em>{" "}
        (fatherland-faith-family) is to associate them in any way with anything
        – god forbid! – <em>queer</em>. In addition, the crass imagery is meant
        to dispel any misconceptions a non-greek observer might have in regards
        to the culture of the so-called "cradle of western civilisation" and to
        curb further uncritical veneration.
      </p>
      <p>
        This series of paintings was conceived and made in 2017 specifically for
        the event{" "}
        <i>Ανάσταση με τα Δοκούμενα * Documena Resurrection Extravaganza</i>,
        which was part of the prelude to the 6th Athens Biennial and positioned
        within a broader (perhaps one-sided) dialogue with Documenta 14 and its
        clumsy appropriation/evocation/instrumentalisation of an imagined{" "}
        <em>greekness</em>.
      </p>
    </>
  ),
  gallery: [
    {
      img: "queerIndigenous1.jpg",
      thumb: "queerIndigenousThumb1.jpg",

      size: "97 × 140 cm",
      material:
        "Latex paint, acrylic paint, pigment powder, charcoal, glue, glitter, newspaper.",
      date: "2017",
      dimensions: {
        width: "2256",
        height: "3328",
      },
    },
    {
      img: "queerIndigenous2.jpg",
      thumb: "queerIndigenousThumb2.jpg",

      size: "110 × 182 cm",
      material:
        "Latex paint, acrylic paint, pigment powder, charcoal, glue, newspaper.",
      date: "2017",
      dimensions: {
        width: "2204",
        height: "3540",
      },
    },
    {
      img: "queerIndigenous3.jpg",
      thumb: "queerIndigenousThumb3.jpg",

      size: "99 × 142 cm",
      material:
        "Latex paint, acrylic paint, pigment powder, charcoal, glue, newspaper.",
      date: "2017",
      dimensions: {
        width: "2412",
        height: "3450",
      },
    },
    {
      img: "queerIndigenous4.jpg",
      thumb: "queerIndigenousThumb4.jpg",

      size: "94 × 116 cm",
      material:
        "Latex paint, acrylic paint, pigment powder, charcoal, glue, newspaper.",
      date: "2017",
      dimensions: {
        width: "2372",
        height: "2996",
      },
    },
    {
      img: "queerIndigenous5.jpg",
      thumb: "queerIndigenousThumb5.jpg",

      size: "117 × 204 cm",
      material:
        "Latex paint, acrylic paint, pigment powder, charcoal, glue, newspaper.",
      date: "2017",
      dimensions: {
        width: "2200",
        height: "3588",
      },
    },
    {
      img: "queerIndigenous6.jpg",
      thumb: "queerIndigenousThumb6.jpg",

      size: "114 × 141 cm",
      material:
        "Latex paint, acrylic paint, pigment powder, charcoal, glue, newspaper.",
      date: "2017",
      dimensions: {
        width: "2624",
        height: "3228",
      },
    },
    {
      img: "queerIndigenous7.jpg",
      thumb: "queerIndigenousThumb7.jpg",

      size: "118 × 139 cm",
      material:
        "Latex paint, acrylic paint, pigment powder, glitter, charcoal, glue, newspaper.",
      date: "2017",
      dimensions: {
        width: "2620",
        height: "2924",
      },
    },
    {
      img: "queerIndigenous8.jpg",
      thumb: "queerIndigenousThumb8.jpg",

      size: "88 × 131 cm",
      material:
        "latex paint, acrylic paint, pigment powder, charcoal, glue, newspaper.",
      date: "2017",
      dimensions: {
        width: "2232",
        height: "3276",
      },
    },
  ],
};
